export class PerformanceTracker {

    count = 0;
    countsWithDuration = 0;
    totalDuration = 0;
    minDuration = Infinity;
    maxDuration = -Infinity;
    averageDuration = 0;

    lastStart: number | undefined;

    constructor(public readonly name: string) {
    }

    markStart() {
        this.lastStart = performance.now();
    }

    reportEnd(): number {
        if (this.lastStart == undefined) {
            console.warn(`PerformanceTracker: reportEnd() called without markStart() for ${this.name}`);
            return -1;
        } else {
            const duration = performance.now() - this.lastStart;
            this.lastStart = undefined;
            this.reportMeasurement(duration);
            return duration;
        }
    }

    reportMeasurement(duration?: number | undefined) {
        this.count++;
        if (duration) {
            this.countsWithDuration++;
            this.totalDuration += duration;
            this.minDuration = Math.min(this.minDuration, duration);
            this.maxDuration = Math.max(this.maxDuration, duration);
            this.averageDuration = this.totalDuration / this.countsWithDuration;
        }
    }

    reset() {
        this.count = 0;
        this.totalDuration = 0;
        this.averageDuration = 0;
    }

    measure<T>(block: () => T): [T, number] {
        let retval: T;
        let duration: number;
        this.markStart();
        try {
            retval = block();
        } finally {
            duration = this.reportEnd();
        }
        return [retval, duration];
    }
}

export class AppPerformanceTrackers {

    static trackerRegistry: Record<string, PerformanceTracker> = {};

    static createPerformanceTracker(name: string) {
        const tracker = new PerformanceTracker(name);
        AppPerformanceTrackers.trackerRegistry[name] = tracker;
        return tracker;
    }

    static AccountGridCellRenderer = AppPerformanceTrackers.createPerformanceTracker('account-grid-cell-renderer');
    static AccountGridCellChangedRenderer = AppPerformanceTrackers.createPerformanceTracker('account-grid-cell-changed-renderer');
    static AccountGridHeatMapRenderer = AppPerformanceTrackers.createPerformanceTracker('account-grid-heat-map-renderer');
    static OpaEvaluation = AppPerformanceTrackers.createPerformanceTracker('opa-evaluation');
    static OpaCacheHits = AppPerformanceTrackers.createPerformanceTracker('opa-cache-hits');
}
